export interface DemoSourcePort<TSource> {
  /** Stores the loader only; it runs on the first `load()`, so the payload stays in its own chunk. */
  register: (load: () => Promise<TSource>) => void;
  /** `null` when nothing is registered: the caller falls through to the real fetch. */
  load: () => Promise<TSource | null>;
}

export const createDemoSourcePort = <TSource>(): DemoSourcePort<TSource> => {
  let loader: (() => Promise<TSource>) | null = null;
  let loaded: Promise<TSource> | null = null;

  return {
    register: load => {
      loader = load;
      loaded = null;
    },
    load: async () => {
      if (!loader) {
        return null;
      }
      loaded ??= loader();

      return loaded;
    },
  };
};
